export default __webpack_public_path__ + "static/media/yelpCamp1.c1983d31.jpg";